import { useProfile } from 'context/Profile'
import { getUsername } from 'utils/users'
import { FormattedMessage } from 'components/Commons/Translation'

import fallbackUser from 'assets/svg/fallback_user.svg'

import { Column, Container, Row, SubTitle, Title, User } from './styled'
import translations from './translations'

function UserInfo() {
  const { profile } = useProfile()
  const username = getUsername(profile)
  return (
    <Container>
      <Row>
        <User
          fallback={fallbackUser}
          picture={profile.picture}
          fit="cover"
          alt={username}
          size="50px"
          className="clarity-mask"
        />
        <Column>
          <Title>
            <FormattedMessage {...translations.userInfoTitle} />
          </Title>
          <SubTitle>
            {username} | {profile.email}
          </SubTitle>
        </Column>
      </Row>
    </Container>
  )
}

export default UserInfo
